import { render, staticRenderFns } from "./NewShareTokenCard.vue?vue&type=template&id=05f80a5c"
import script from "./NewShareTokenCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewShareTokenCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports